import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { DOMAIN_URL } from 'constants/common';
import { ROUTES } from 'constants/routes';
import { type CreatePatientPackPayload, type PackCheckout } from 'types/billing';
import { getUserId } from 'utils/storage';

const API_URL = `${BASE_URL}billing`;

export interface BillingServiceTypes {
  createPatientPack: (body: CreatePatientPackPayload) => Promise<PackCheckout>;
}

export const BillingService: BillingServiceTypes = {
  createPatientPack: body =>
    service
      .post(`${API_URL}/checkout/patients/${getUserId()}`, body, {
        params: {
          successUrl: `${DOMAIN_URL}${ROUTES.APPOINTMENTS_CHECKOUT}?isSuccess=true`,
          cancelUrl: `${DOMAIN_URL}${ROUTES.APPOINTMENTS_CHECKOUT}`,
        },
      })
      .then(response => response.data),
};
